import { repositories } from 'ui-common'
import profile from './profile'
import epworth from './epworth'
import screener from './screener'

export default {
  ...repositories,
  profile,
  epworth,
  screener
}
